import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";

import type { NavigatorProps } from "..";

export const useNavigateLangCode = (navigator: NavigatorProps) => {
	const navigate = useNavigate();
	const location = useLocation();

	const handleClickNavigate = useCallback(
		(langCode: LangCode) => () => {
			const path = langCode === LangCode.Default ? navigator.default : navigator.i18n?.(langCode);
			const currentPathname = location.pathname;

			const canNavigate = path && currentPathname !== path;
			if (!canNavigate) return;
			// 現在のpathと違う場合のみ遷移する
			navigate(path);
		},
		[navigate, navigator, location.pathname],
	);

	return { handleClickNavigate };
};
